import gql from 'graphql-tag'

export const GET_INVOICE_URL = gql`
  query InvoiceUrl($transactionId: ID!) {
    invoiceUrl(transactionId: $transactionId)
  }
`
